import React from 'react';
import PropTypes from 'prop-types';
import { get, orderBy } from 'lodash';
import CoreMap from '@bd/bdui-coremap';
import { css } from '@bd/bdui-styles/emotion';
import withData from '@bd/bdcore-data';
import AppliedFilters from '@bd/bdui-appliedfilters';
import numeral from 'numeral';
import { Link } from '@bd/bdcore-named-routes';
import CommunityCard from '../../components/CommunityCard';
import { colors } from '../../styles';

const styles = css`
  display: none;
  @media(min-width: 768px) {
    display: block;
  }
  .Welcome {
    margin: -40px 0 0 0;
    position: relative;
    z-index: 4;
    @media(min-width: 768px) {
      margin: 0;
    }
  }
  .Welcome_title {
    color: ${colors.brand1};
    font-weight: 300;
    font-size: 36px;
    text-align: center;
    @media(min-width: 768px) {
      font-size: 48px;
    }
  }
  .Welcome_text {
    text-align: center;
    font-weight: 400;
    font-size: 18px;
    padding: 0 40px;
    @media(min-width: 768px) {
      font-size: 21px;
      padding: 0 0 40px 0;
    }
  }
  .Communities_communitiesResults {
    display: none;
    position: relative;
    z-index: 1;
    @media(min-width: 768px) {
      display: flex;
    }
  }

  .Communities_communitiesList {
    display: none;
    height: auto;
    @media (min-width: 992px) {
      display: block !important;
      width: 542px;
      padding: 30px;
      background-color: ${colors.neutral};
      padding: 20px;
      height: 945px;
      overflow-y: scroll;
    }
  }
`;

const communityMap = css`
  display: block;
  height: 80vh;
  width: 100vw;
  @media(min-width: 992px) {
    width: auto;
    height: 945px;
    flex-grow: 1;
    background-color: ${colors.neutral};
    order: 1;
  }
  .leaflet-container {
    width: 100%;
    height: 100%;
  }
  .leaflet-popup-content-wrapper {
    width: 240px;
    border-radius: 0;
    .leaflet-popup-content {
      color: ##8e8e8e;
      line-height: 1.4;
      padding: 25px 15px;
      margin: 0;
      width: 100% !important;

      img {
        width: 100%;
        height: 147px;
        object-fit: cover;
      }

      h3 {
        color: ${colors.brand1};
        letter-spacing: 0.37px;
        margin-bottom: 0;
        font-weight: 600;
        font-size: 20px;
        font-family: acumin-pro-condensed,sans-serif;
        color: ${colors.brand1};
        margin: 5px 0 10px;
      }

      span {
        font-size: 14px;
      }

      .ButtonDefault {
        width: 198px;
        height: 40px;
        padding-left: 0;
        justify-content: center;
        font-size: 12px;
        color: ${colors.white};
        letter-spacing: 2.16px;
        min-width: 198px;
        &::after {
          content: "";
        }
      }
    }
    .CommunityCard_wrapper {
      width: 100% !important;
    }
    .CommunityCard_inner {
      flex-direction: column !important;
    }
    .CommunityCard_mapButton {
      display: none !important;
    }
    .CommunityCard_detailButton {
      width: 100% !important;
    }
    .CommunityCard_buttonWrapper {
      margin: 0 !important;
    }
    .CommunityCard_priceValue {
      padding: 10px 8px !important;
    }
  }
  .Map {
    display: flex;
    flex-direction: column;

    img {
      display: none;
      @media(min-width: 768px) {
        display: block;
      }
    }
    h3 {
      text-align: left;
    }
  }
  .CommunityCard_detailButton {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 40px;
    text-align: center;
    background-color: ${colors.brand2};
    color: ${colors.white};
    font-weight: 800;
    font-size: 13px;
    text-transform: uppercase;
    margin-top: 10px;
    transition: all .3s ease-out;
    &:hover {
      background-color: ${colors.brand2};
      transition: all .3s ease-out;
    }
    &::after {
      content: url(/images/btn-right-arrow.svg);
      margin-left: 10px;
    }
  }
`;

function HomepageMap({ communities, activeMapPin, page }) {
  return (
    <div className={styles}>
      {
        communities.length > 0 &&
        <div>
          <div className="Welcome_section" id="welcome">
            <div className="container">
              <h3 className="Welcome_title">{get(page, 'welcome_section[0].lead_copy')}</h3>
              <h4 className="Welcome_text">{get(page, 'welcome_section[0].body_copy')}</h4>
            </div>
          </div>
          <div className="Communities_communitiesResults">
            <AppliedFilters className="d-none" clearOnLoad />
            <CoreMap
              boundsOptions={{ animate: true, duration: 0.5 }}
              pin={{
                iconUrl: '/images/icon-map-pin.svg',
                iconSize: [25, 36],
                iconAnchor: [11, 30],
                popupAnchor: [0, -35],
              }}
              activePin={activeMapPin}
              className={communityMap}
              markers={communities}
              popup={({ marker: community }) => (
                <div className="Map">
                  {
                    (get(community, 'logo.contentUrl') || get(community, 'photos[0].contentUrl')) &&
                    <img src={(get(community, 'logo.contentUrl') || get(community, 'photos[0].contentUrl'))} alt="Community Logo" />
                  }
                  {
                    !get(community, 'logo.contentUrl') && !get(community, 'photos[0].contentUrl') &&
                    <img src="/images/coming-soon.jpg" alt="Comming Soon" />
                  }
                  <h3>{community.name}</h3>
                  <span><b>Location:</b> {community.address.addressLocality}</span>
                  {
                    get(community, 'priceLow') &&
                    <span><b>From:</b> {numeral(get(community, 'priceLow', '')).format('$0,0')}</span>
                  }
                  {
                    get(community, 'sqftLow', '') &&
                    <span><b>SQFT Range:</b> {numeral(get(community, 'sqftLow', '')).format('0,0')}{get(community, 'sqftHigh') > 0 ? ` - ${numeral(get(community, 'sqftHigh')).format('0,0')}` : '+'}</span>
                  }
                  <Link name="community-detail" community={community} className="CommunityCard_detailButton">Visit Community</Link>
                </div>
              )}
              boundaryPadding={17}
            />
            <div className="Communities_communitiesList">
              {
                orderBy(communities, 'status', 'name').map(community => (
                  <CommunityCard key={community._id} community={community} />
                ))
              }
              {
                !communities.length > 0 &&
                <p>There are no projects currently available here
                   at this time. Please check back again soon!</p>
              }
            </div>
          </div>
        </div>
      }
    </div>
  );
}

HomepageMap.propTypes = {
  communities: PropTypes.arrayOf(PropTypes.object).isRequired,
  activeMapPin: PropTypes.string,
  page: PropTypes.object.isRequired,
};

HomepageMap.defaultProps = {
  activeMapPin: undefined,
};

export default withData(
  {
    communities: true,
    activeMapPin: true,
  },
  {
    required: {
      communities: true,
    },
  },
)(HomepageMap);



// WEBPACK FOOTER //
// ./src/pages/IndexPage/HomepageMap.js